import React from 'react';
import styled from 'styled-components';

const Imprint = () => {
  return (
    <PageContainer>
      <Section>
        <ContentWrapper>
          <PagePill>Legal Notice</PagePill>

          <MainHeading>Legal Notice / Impressum</MainHeading>

          <IntroText>
            Sonorai is a brand operated by Elgazzar Ventures LLC. This page
            provides the company's legal identity and contact information.
          </IntroText>

          <ContentSection>
            <SectionHeading>Operator</SectionHeading>
            <InfoText>
              Elgazzar Ventures LLC<br />
              Brand: Sonorai<br />
              Legal form: Limited liability company (Wyoming, United States)
            </InfoText>
          </ContentSection>

          <ContentSection>
            <SectionHeading>Registered Address</SectionHeading>
            <InfoText>
              33 North Gould Street<br />
              Sheridan, WY 82801<br />
              United States
            </InfoText>
          </ContentSection>

          <ContentSection>
            <SectionHeading>Contact</SectionHeading>
            <InfoText>
              Phone: <a href="tel:+17372822831">+1 (737) 282-2831</a><br />
              Email: <a href="mailto:mohamed@sonorai.co">mohamed@sonorai.co</a>
            </InfoText>
          </ContentSection>

          <ContentSection>
            <SectionHeading>Business Activity</SectionHeading>
            <InfoText>
              Technology / IT services / AI automation services. The operator
              designs and delivers AI voice agents, automation systems, CRM
              integrations, and related consulting services.
            </InfoText>
          </ContentSection>

          <ContentSection>
            <SectionHeading>Responsible for Content</SectionHeading>
            <InfoText>
              Elgazzar Ventures LLC, at the address above.
            </InfoText>
          </ContentSection>

          <ContentSection>
            <SectionHeading>Liability for Content</SectionHeading>
            <InfoText>
              The contents of this website have been prepared with care, but we
              do not guarantee their accuracy, completeness, or timeliness. As a
              service provider we are responsible for our own content on these
              pages under applicable laws. We are not obliged to monitor
              third-party information transmitted or stored, nor to investigate
              circumstances that point to unlawful activity. Obligations to
              remove or block the use of information under applicable law remain
              unaffected.
            </InfoText>
          </ContentSection>

          <ContentSection>
            <SectionHeading>Liability for Links</SectionHeading>
            <InfoText>
              This website includes links to external third-party websites,
              including but not limited to Cal.com, YouTube, and other service
              providers. We have no influence on the content of those websites
              and cannot accept liability for them. Linked websites were
              reviewed for unlawful content at the time of linking; no unlawful
              content was apparent at that point. Continuous monitoring of
              linked content is not reasonable without concrete indications of a
              violation. We will remove such links promptly once we become aware
              of a violation.
            </InfoText>
          </ContentSection>

          <ContentSection>
            <SectionHeading>Copyright</SectionHeading>
            <InfoText>
              All content and works created by the site operator on these pages
              are protected by Italian and international copyright law.
              Reproduction, modification, distribution, or any form of use
              beyond the limits of copyright law requires the prior written
              consent of the operator. Downloads and copies are permitted only
              for private, non-commercial use. Where content was not created by
              the operator, third-party rights are respected and such content is
              marked accordingly. If you become aware of a copyright
              infringement, please notify us and we will remove the content
              promptly.
            </InfoText>
          </ContentSection>

          <ContentSection>
            <SectionHeading>Online Dispute Resolution</SectionHeading>
            <InfoText>
              The European Commission provides an online dispute resolution
              platform at{' '}
              <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
                https://ec.europa.eu/consumers/odr
              </a>
              . We are not obliged or willing to participate in dispute
              resolution proceedings before a consumer arbitration board.
            </InfoText>
          </ContentSection>

          <LastUpdated>Company details updated: September 10, 2026</LastUpdated>
        </ContentWrapper>
      </Section>
    </PageContainer>
  );
};

const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  background-color: var(--bg-0);
`;

const Section = styled.section`
  padding: 120px 20px 100px;
  max-width: 1200px;
  margin: 0 auto;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 780px;
  margin: 0 auto;
`;

const PagePill = styled.div`
  display: inline-block;
  padding: 6px 14px;
  background-color: var(--bg-2);
  border: 1px solid var(--line-2);
  border-radius: 9999px;
  color: var(--fg-2);
  font-family: var(--mono);
  font-size: 11px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.28px;
  margin-bottom: 24px;
  align-self: flex-start;
`;

const MainHeading = styled.h1`
  font-family: var(--display);
  font-size: 56px;
  font-weight: 400;
  letter-spacing: -1.6px;
  color: var(--fg-0);
  margin: 0 0 24px;
  line-height: 1.05;

  @media (max-width: 768px) {
    font-size: 40px;
    letter-spacing: -1px;
  }
`;

const IntroText = styled.p`
  font-family: var(--body);
  font-size: 17px;
  line-height: 1.55;
  color: var(--fg-2);
  margin: 0 0 48px;
  max-width: 680px;
`;

const ContentSection = styled.div`
  margin-bottom: 36px;
`;

const SectionHeading = styled.h2`
  font-family: var(--body);
  font-size: 18px;
  font-weight: 600;
  color: var(--fg-0);
  margin: 0 0 12px;
  letter-spacing: -0.2px;
`;

const InfoText = styled.p`
  font-family: var(--body);
  font-size: 15.5px;
  line-height: 1.65;
  color: var(--fg-1);
  margin: 0 0 12px;

  a { color: var(--blue); text-decoration: underline; }
  a:hover { color: var(--fg-0); }
`;

const LastUpdated = styled.p`
  font-family: var(--mono);
  font-size: 11px;
  color: var(--fg-3);
  text-transform: uppercase;
  letter-spacing: 0.28px;
  margin-top: 48px;
  padding-top: 24px;
  border-top: 1px solid var(--line-2);
`;

export default Imprint;
